import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import { getSize } from '@lib/common';
import styled from '@xstyled/styled-components';
import { AiChangeType } from '../../../../../../../ai';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: ", ";\n  vertical-align: middle;\n  margin: ", " ", ";\n  flex-wrap: wrap;\n"])), getSize('padding8'), getSize('padding4'), getSize('padding8'));

var getIndexCircleBackground = function getIndexCircleBackground($changeType) {
  if ($changeType === AiChangeType.Delete) {
    return '#94a3b8';
  }

  if ($changeType === AiChangeType.Update) {
    return '#facc15';
  }

  return '#2563eb';
};

var IndexCircle = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  color: #ffffff;\n  font-size: ", ";\n  font-weight: 800;\n  line-height: 1;\n  flex-shrink: 0;\n"])), getSize('padding20'), getSize('padding20'), function (_ref) {
  var $changeType = _ref.$changeType;
  return getIndexCircleBackground($changeType);
}, getSize('typo12'));
var StyledInputBox = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  min-width: 80px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 4px 12px;\n  background: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: ", ";\n  font-weight: 600;\n  line-height: 1.5;\n\n  ", "\n"])), getSize('typo16'), function (_ref2) {
  var $changeType = _ref2.$changeType;
  return $changeType === AiChangeType.Delete && "\n    background-color: #f8fafc;\n    border-color: #e2e8f0;\n    opacity: 0.8;\n  ";
});
var StyledBeforeValue = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: #ef4444;\n  text-decoration: line-through;\n  background-color: #fef2f2;\n  border-radius: 2px;\n  padding: 0 4px;\n"])));
var StyledAfterValue = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: #16a34a;\n  font-weight: 600;\n  background-color: #f0fdf4;\n  border-radius: 2px;\n  padding: 0 4px;\n"])));
var StyledNormalValue = styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: #1e293b;\n"])));
export var FillInBlankInput = function FillInBlankInput(_ref3) {
  var index = _ref3.index,
      _ref3$value = _ref3.value,
      value = _ref3$value === void 0 ? '' : _ref3$value,
      _ref3$beforeValue = _ref3.beforeValue,
      beforeValue = _ref3$beforeValue === void 0 ? '' : _ref3$beforeValue,
      changeType = _ref3.changeType;
  var hasChanged = changeType === AiChangeType.Update && beforeValue && beforeValue !== value;
  var strategies = {
    add: {
      render: function render(val, bVal) {
        return /*#__PURE__*/_jsx(StyledNormalValue, {
          children: val || bVal
        });
      }
    },
    update: {
      render: function render(val, bVal, changed) {
        return changed ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(StyledBeforeValue, {
            children: bVal
          }), /*#__PURE__*/_jsx(StyledAfterValue, {
            children: val
          })]
        }) : /*#__PURE__*/_jsx(StyledNormalValue, {
          children: val || bVal
        });
      }
    },
    remove: {
      render: function render(val, bVal) {
        return /*#__PURE__*/_jsx(StyledBeforeValue, {
          children: val || bVal
        });
      }
    }
  };
  var strategy = strategies[changeType] || strategies.update;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(IndexCircle, {
      $changeType: changeType,
      children: index
    }), /*#__PURE__*/_jsx(StyledInputBox, {
      $changeType: changeType,
      children: strategy.render(value, beforeValue, hasChanged)
    })]
  });
};